declare global {
  interface Window {
    fbq: (...args: unknown[]) => void
    _fbq: (...args: unknown[]) => void
  }
}

export function initMetaPixel() {
  if (window.fbq) return

  const n: any = (window.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
  })
  if (!window._fbq) window._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = []

  const t = document.createElement('script')
  t.async = true
  t.src = 'https://connect.facebook.net/en_US/fbevents.js'
  document.head.appendChild(t)

  // Also add noscript pixel
  const noscript = document.createElement('noscript')
  const img = document.createElement('img')
  img.height = 1
  img.width = 1
  img.style.display = 'none'
  img.src =
    'https://www.facebook.com/tr?id=958699360076044&ev=PageView&noscript=1'
  noscript.appendChild(img)
  document.body.appendChild(noscript)

  window.fbq('init', '958699360076044')
  window.fbq('track', 'PageView')
  window.fbq('track', 'ViewContent', {
    content_name: 'The 365 Garden Shield',
    content_category: 'Digital Product',
    value: 6.37,
    currency: 'USD',
  })
}

export function trackAddToCart() {
  if (window.fbq) {
    window.fbq('track', 'AddToCart', {
      content_name: 'The 365 Garden Shield',
      content_type: 'product',
      value: 6.37,
      currency: 'USD',
    })
  }
}
